var _path, _path2, _path3, _path4, _g, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_501_5524)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.2581 86.7499C70.6256 86.7499 88.758 68.6175 88.758 46.2499C88.758 23.8824 70.6256 5.74994 48.2581 5.74994C25.8905 5.74994 7.75806 23.8824 7.75806 46.2499C7.75806 68.6175 25.8905 86.7499 48.2581 86.7499Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2581 82.25C68.1403 82.25 84.258 66.1323 84.258 46.25C84.258 26.3678 68.1403 10.25 48.2581 10.25C28.3758 10.25 12.2581 26.3678 12.2581 46.25C12.2581 66.1323 28.3758 82.25 48.2581 82.25Z",
    fill: "#C1C7D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1294 53.2481C28.1294 53.2481 46.7269 50.1858 68.9095 53.2481C68.9095 53.2481 69.5817 71.3975 48.5194 71.3975C27.4572 71.3975 28.1294 53.2481 28.1294 53.2481Z",
    fill: "#505F79"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_501_5524",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 51,
    width: 41,
    height: 21
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1294 53.2481C28.1294 53.2481 46.7269 50.1858 68.9095 53.2481C68.9095 53.2481 69.5817 71.3975 48.5194 71.3975C27.4572 71.3975 28.1294 53.2481 28.1294 53.2481Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_501_5524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.5195 80.3601C58.0893 80.3601 65.8473 76.3474 65.8473 71.3975C65.8473 66.4475 58.0893 62.4348 48.5195 62.4348C38.9496 62.4348 31.1917 66.4475 31.1917 71.3975C31.1917 76.3474 38.9496 80.3601 48.5195 80.3601Z",
    fill: "#8993A4"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9717 28.6755C33.9551 29.1983 32.4614 30.9909 32.2373 32.8581C31.117 31.3643 28.951 30.468 26.9344 30.9909C24.395 31.6631 22.9012 34.0531 23.5734 36.6672C24.4697 40.1776 29.0257 42.0448 35.5236 45.9286C39.4074 39.356 42.4697 35.6216 41.5734 32.1112C40.9759 29.4224 38.5112 28.0033 35.9717 28.6755Z",
    fill: "#505F79"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.6191 28.6755C58.0797 28.0033 55.6149 29.4224 54.9427 32.0365C54.0465 35.5469 57.1087 39.356 60.9925 45.8539C67.5651 41.9701 72.0465 40.1029 72.9427 36.5925C73.6149 33.9784 72.1212 31.5884 69.5817 30.9162C67.5651 30.3933 65.3992 31.2149 64.2788 32.7834C64.1295 30.9908 62.6357 29.1983 60.6191 28.6755Z",
    fill: "#505F79"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_501_5524",
    x: -3.94194,
    y: -4.15,
    width: 104.4,
    height: 104.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_501_5524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_501_5524",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEx);
export default __webpack_public_path__ + "static/media/ex.471a9a0c3bc01c8525742514a580df5d.svg";
export { ForwardRef as ReactComponent };